module.exports = __webpack_public_path__ + "img/pay-as-little-as-25.a89576f5.png";